import React, { Component } from 'react';
import { connect } from 'react-redux'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter, Redirect } from 'react-router-dom'
import { Upload } from 'antd'

import { actionCreators } from './store'
import styles from './index.module.css'

import ChatMessage from './components/ChatMessage'
import ChatMessageHeader from './components/ChatMessageHeader';
import SideBar from './components/SideBar'
import BeginnerGuide from './components/BeginnerGuide'
import ModalFeedback from '../../common/ModalFeedback'
import ModalFeedbackDone from '../../common/ModalFeedbackDone'
import ModalUserInfo from '../../common/ModalUserInfo'
import SideBarArrow from './components/SideBarArrow'
import ModalImageView from './components/ModalImageView'
import UserResearch from './components/UserResearch'
import ImageMover from './components/ImageMover'
import ModalBlockUsage from './components/ModalBlockUsage'
import ModalOverallUpdateInfo from './components/ModalOverallUpdateInfo'
import ChatMessageFooter from './components/ChatMessageFooter'
import ModalExperienceUpdateInfo from './components/ModalExperienceUpdateInfo'
import ScreenPersonalOverview from './components/ScreenPersonalOverview'
import ScreenStoneModelMall from './components/ScreenStoneModelMall'
import ScreenPersonalBackpack from './components/ScreenPersonalBackpack'
import MyConfetti from '../../common/MyConfetti'
import MobileHome from './components/MobileHome'

import introVideo from '../../statics/intro.mp4'; // 导入视频
import { detectDevice } from '../../utils';
import addImg from '../../statics/content_drag_add_vector.png'


const MaterialModeDrag = () => {
    const dispatch = useDispatch()
    let material_mode_progress = useSelector(state => state.get('home').get('material_mode_progress'))
    let active_date = useSelector(state => state.get('home').get('active_date'))
    let active_topicid = useSelector(state => state.get('home').get('active_topicid'))

    const handleUpload = (info) => {
        const { file } = info;
        console.log("handleUpload ========================== file = ", file);

        if (file.status === 'uploading') {
            dispatch(actionCreators.materialModeUploading(true))
        }

        if (file.status === 'done') {
            dispatch(actionCreators.materialModeUploading(false))
            dispatch(actionCreators.materialModeProgress(100))  // 上传完成后将进度设置为 100%
            // message.success(`${file.name} 上传成功`);
            dispatch(actionCreators.isMaterialModeDragging(false))
        } else if (file.status === 'error') {
            dispatch(actionCreators.materialModeUploading(false))
            dispatch(actionCreators.materialModeProgress(0))
            dispatch(actionCreators.materialModePreviewImage(null))
            dispatch(actionCreators.materialModePreviewImageData({}))
            // message.error(`${file.name} 上传失败`);
            dispatch(actionCreators.isMaterialModeDragging(false))
        }
    }

    const customRequest = ({ file, onProgress, onSuccess, onError }) => {
        console.log("customRequest =================== file = ", file);
        const interval = setInterval(() => {
            const newProgress = material_mode_progress + 10;
            console.log("setInterval newProgress = ", newProgress);
            if (newProgress >= 90) {
                clearInterval(interval); // 接近完成时停止模拟进度
            }
            onProgress({ percent: newProgress }, file);
            dispatch(actionCreators.materialModeProgress(newProgress))
        }, 500);

        // 假设这是你添加的图片的 API
        const formData = new FormData();
        formData.append('image', file);

        dispatch(actionCreators.imageSearchUploadImage(formData, interval))
            .then((data) => {
                // dispatch(actionCreators.materialModePreviewImageData(data.data))
                onSuccess(null, file); // 上传成功
            })
            .catch((error) => {
                onError(error, file); // 上传失败
            })
            .finally(() => {
                // clearInterval(interval);
            })
    }

    const handlePreview = (file) => {
        console.log("handlePreview file = ", file);
        const reader = new FileReader();
        reader.onload = (e) => {
            dispatch(actionCreators.materialModePreviewImage(e.target.result))
        };
        reader.readAsDataURL(file);
    }

    return (
        <div className={`${styles.content_drag_area_modal} ${active_date === '' && active_topicid === '' ? styles.content_drag_area_modal_none : null}`}>
            <div className={styles.content_drag_area_box}>
                {/* <Upload.Dragger
                    name="file"
                    customRequest={customRequest}
                    onChange={handleUpload}
                    showUploadList={false}
                    beforeUpload={(file) => {
                        handlePreview(file);
                        return true;
                    }}
                    maxCount={1} // 限制上传数量为 1
                    accept={"image/*"}
                    multiple={false}
                    className={styles.custome_drag_area_upload}
                > */}
                    <div className={styles.content_drag_area}>
                        <div className={styles.content_drag_dashed}>
                            <img src={addImg} alt="add icon" />
                            <div className={styles.content_drag_title}>添加物料照片</div>
                            <div className={styles.content_drag_text}>将任意文件拖放到此处，以将其添加到对话中</div>
                        </div>
                    </div>
                {/* </Upload.Dragger> */}
            </div>
        </div>
    )
}

class Home extends Component {
    componentDidMount () {
        if (this.props.has_login) {
            console.log("获取所有历史记录");
            this.props.handleInitAllConversationHistory()
            // 获取 release 的版本更新信息
            this.props.handleGetReleaseContent()
            // 清除 url 上多余的参数
            this.clearExcessParameters()
            // 获取经验值等级信息
            this.props.handleGetLevelInfo()
            // 获取用户的当前经验值
            this.props.handleGetLevelChatCount()
            // 获取当前用户的商城中的组件列表
            this.props.handleGetStoreComponentsList()
            // 获取灵石助手的历史记录
            this.props.handleGetAssistantMessageForConversation()
            // 获取用户当天使用的问答次数
            this.props.handleGetChatCountData()
            // 获取用户当前环境是否是移动端
            this.getIsMobile()
        }
    }

    onVideoEnd () {
        this.props.handleIsShowIntroVideoAction(false)
        this.props.handleIsShowImageMoverAction(true)
    }

    isEmptyModel () {
        if (
            !this.props.is_show_screen_personal_overview &&
            !this.props.is_show_screen_stone_model_mall &&
            !this.props.is_show_screen_personal_backpack &&
            this.props.active_date === '' &&
            this.props.active_topicid === ''
        ) {
            return true
        } else {
            return false
        }
    }

    clearExcessParameters () {
        // console.log("============before===========");
        // console.log("this.props = ", this.props);
        // console.log("============before===========");

        // 使用 window.location 对象获取URL的各个部分
        let { protocol, host, pathname } = window.location;
        pathname = '/#/home'

        // 构建新的不包含查询字符串的URL
        const newUrl = `${protocol}//${host}${pathname}`;

        // 使用 history.replaceState 更新页面状态和 URL（不会添加新的历史记录）
        window.history.replaceState({}, document.title, newUrl);
    }

    getIsMobile () {
        if (detectDevice() === 'mobile_enterprise_wechat' || detectDevice() === 'mobile_browser') {
            this.props.handleIsMobileAction(true)
        }
    }

    handleDragEnter(e) {
        console.log("handleDragEnter");
        // 处理拖拽进入
        e.preventDefault()
        this.props.handleIsMaterialModeDragging(true)
    }

    handleDragLeave(e) {
        console.log("handleDragLeave");
        // 处理拖拽离开
        e.preventDefault()
        if (e.currentTarget.contains(e.relatedTarget)) return;
        this.props.handleIsMaterialModeDragging(false)
    }

    handleDragOver(e) {
        // 处理拖拽悬浮
        e.preventDefault()
        e.stopPropagation()
    }

    handleDrop(e) {
        e.preventDefault()
        e.stopPropagation()
        // const files = e.dataTransfer.files;
        // console.log('Dropped files:', files);

        console.log("e = ", e.target.classList);
        // 将 classList 转换为数组
        const classList = Array.from(e.target.classList);

        // 使用正则表达式检查是否存在匹配的 class
        const containsClass = classList.some((className) =>
            /content_drag_area_modal/i.test(className) || /content_drag_area_box/i.test(className)
        );

        if (containsClass) {
            console.log("handleDrop ============ ");
            this.props.handleIsMaterialModeDragging(false)
        } else {
            const files = e.dataTransfer.files;
            const file0 = files[0]
            console.log('Dropped file0:', file0);
            // 预览图
            this.handlePreview(file0)
            // 上传以及上传进度
            this.customRequest(file0)
            // 上传中
            this.props.handleMaterialModeUploading(true)
            // 隐藏拖拽展示框
            this.props.handleIsMaterialModeDragging(false)
        }
    }

    customRequest(file) {
        console.log("customRequest ===================");
        const interval = setInterval(() => {
            const newProgress = this.props.material_mode_progress + 10;
            console.log("home setInterval newProgress = ", newProgress);
            if (newProgress >= 90) {
                clearInterval(interval); // 接近完成时停止模拟进度
            }
            this.props.handleMaterialModeProgressvalue(newProgress)
        }, 500);

        // 假设这是你添加的图片的 API
        const formData = new FormData();
        formData.append('image', file);

        this.props.handleImageSearchUploadImage(formData, interval)
    }

    handlePreview(file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            // dispatch(actionCreators.materialModePreviewImage(e.target.result))
            this.props.handleMaterialModePreviewImage(e.target.result)
        };
        reader.readAsDataURL(file);
    }

    render () {
        if (!this.props.has_login) {
            return <Redirect to="/" />
        }

        if (this.props.is_show_user_research) {
            return (
                <UserResearch />
            )
        }

        if (this.props.is_show_intro_video) {
            return (
                <div className={styles.video_box}>
                    <video
                        src={introVideo}
                        width="100%"
                        height="100%"
                        autoPlay={true}
                        muted={true} // 静音播放
                        preload="auto"
                        onEnded={this.onVideoEnd.bind(this)}
                    ></video>
                </div>
            )
        }
        if (this.props.is_show_image_mover) {
            return (
                <ImageMover />
            )
        }
        if (this.props.is_mobile) {
            return (
                <MobileHome />
            )
        }

        // 专家切换的时候，新的界面改成渐出
        let is_empty_model = this.isEmptyModel()
        let keyHeaderProps = is_empty_model ? { key: `header` } : {}
        let keyContentProps = is_empty_model ? { key: `content` } : {}
        let materialModeDragProps = this.props.is_material_mode ? {
            onDragEnter: this.handleDragEnter.bind(this),
            onDragLeave: this.handleDragLeave.bind(this),
            onDragOver: this.handleDragOver.bind(this),
            onDrop: this.handleDrop.bind(this),
        } : {}

        let main_unit = ''
        if (this.props.is_show_screen_personal_overview) {
            main_unit = <ScreenPersonalOverview />
        } else if (this.props.is_show_screen_stone_model_mall) {
            main_unit = <ScreenStoneModelMall />
        } else if (this.props.is_show_screen_personal_backpack) {
            main_unit = <ScreenPersonalBackpack />
        } else {
            main_unit = <ChatMessage />
        }

        return (
            <div className={styles.container}>
                <div className={`${styles.sidebar} ${this.props.is_zoom ? styles.hide_sidebar : ''}`}>
                    <SideBar />
                </div>

                <div
                    className={`${styles.content} ${this.props.is_zoom ? styles.content_zoom : ''}`}
                    // 通过展开运算符动态绑定事件
                    {...materialModeDragProps}
                >
                    <div className={`${styles.header} ${is_empty_model ? styles.ease_in_out : ''}`} {...keyHeaderProps}>
                        <ChatMessageHeader />
                    </div>

                    <div className={`${styles.main} ${is_empty_model ? styles.ease_in_out : ''}`} {...keyContentProps}>
                        {
                            main_unit
                        }
                    </div>

                    <div className={styles.side_arrow}>
                        <SideBarArrow />
                    </div>

                    <div className={styles.footer}>
                        <ChatMessageFooter />
                    </div>

                    {
                        this.props.is_material_mode && this.props.is_material_mode_dragging ? (
                            <MaterialModeDrag />
                        ) : null
                    }
                </div>

                <ModalFeedback />
                <ModalFeedbackDone />
                <ModalUserInfo />
                <BeginnerGuide />
                <ModalImageView />
                <ModalBlockUsage />
                <ModalOverallUpdateInfo />
                <ModalExperienceUpdateInfo />
                <MyConfetti />
                {/* <ModalOverallUpdateInfo /> */}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        has_login: state.get('login').get('has_login'),
        is_zoom: state.get('home').get('is_zoom'),
        is_show_intro_video: state.get('home').get('is_show_intro_video'),
        is_show_screen_personal_overview: state.get('home').get('is_show_screen_personal_overview'),
        is_show_screen_stone_model_mall: state.get('home').get('is_show_screen_stone_model_mall'),
        is_show_screen_personal_backpack: state.get('home').get('is_show_screen_personal_backpack'),
        is_show_user_research: state.get('home').get('is_show_user_research'),
        is_show_image_mover: state.get('home').get('is_show_image_mover'),
        is_mobile: state.get('home').get('is_mobile'),
        active_date: state.get('home').get('active_date'),
        active_topicid: state.get('home').get('active_topicid'),
        is_material_mode: state.get('home').get('is_material_mode'),
        is_material_mode_dragging: state.get('home').get('is_material_mode_dragging'),
        material_mode_uploading: state.get('home').get('material_mode_uploading'),
        material_mode_progress: state.get('home').get('material_mode_progress'),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleIsShowIntroVideoAction (status) {
            dispatch(actionCreators.isShowIntroVideoAction(status))
        },
        handleInitAllConversationHistory () {
            dispatch(actionCreators.initAllConversationHistory())
        },
        handleIsShowImageMoverAction (status) {
            dispatch(actionCreators.isShowImageMoverAction(status))
        },
        handleGetReleaseContent () {
            dispatch(actionCreators.getReleaseContent())
        },
        handleGetLevelInfo () {
            dispatch(actionCreators.getLevelInfo())
        },
        handleGetLevelChatCount () {
            dispatch(actionCreators.getLevelChatCount())
        },
        handleGetStoreComponentsList () {
            dispatch(actionCreators.getStoreComponentsList())
        },
        handleGetAssistantMessageForConversation () {
            dispatch(actionCreators.getAssistantMessageForConversation())
        },
        handleGetChatCountData () {
            dispatch(actionCreators.getChatCountData())
        },
        handleIsMobileAction (status) {
            dispatch(actionCreators.isMobileAction(status))
        },
        handleIsMaterialModeDragging(status) {
            dispatch(actionCreators.isMaterialModeDragging(status))
        },
        handleMaterialModePreviewImage(value) {
            dispatch(actionCreators.materialModePreviewImage(value))
        },
        handleImageSearchUploadImage(formData, interval) {
            dispatch(actionCreators.imageSearchUploadImage(formData, interval))
        },
        handleMaterialModePreviewImageData(data) {
            dispatch(actionCreators.materialModePreviewImageData(data))
        },
        handleMaterialModeProgressvalue(value) {
            dispatch(actionCreators.materialModeProgress(value))
        },
        handleMaterialModeUploading(status) {
            dispatch(actionCreators.materialModeUploading(status))
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))